export var UI_MODIFICATIONS_ANALYTICS_CHANNEL = 'ui-modifications';